"use client";

import Styles from './NSLabel.module.css'
import React from "react";
import { ReactNode } from "react";
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import { StringFormatter } from '../main';

export interface NSLabelProps extends IBaseComponentProps
{
    title: string;
    desciption?: string;
    children?: ReactNode;
}

export interface NSLabelState
{ }

export class NSLabel extends React.Component<NSLabelProps, NSLabelState>
{
    override render()
    {
        return (
            <div id={this.props.id} className={`${Styles.ns_label_item} ${this.props.classList?.join(" ") ?? ""}`} style={this.props.style}>
                <span className={`${Styles.ns_label_title} ns_font_16_bold`}>
                    {this.props.title}
                </span>
                {
                    this.props.desciption &&
                    <div>
                        <span className={`${Styles.ns_label_desciption}`}>
                            {StringFormatter.toHTML(this.props.desciption)}
                        </span>
                    </div>
                }
                {

                    this.props.children &&
                    <>
                        <div>
                            {this.props.children}
                        </div>
                    </>
                }
            </div >
        );
    }
}